import { render, staticRenderFns } from "./Lgx02829386362116127064980.vue?vue&type=template&id=02fbbc00&scoped=true&"
import script from "./Lgx02829386362116127064980.vue?vue&type=script&lang=js&"
export * from "./Lgx02829386362116127064980.vue?vue&type=script&lang=js&"
import style0 from "./Lgx02829386362116127064980.vue?vue&type=style&index=0&id=02fbbc00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fbbc00",
  null
  
)

export default component.exports